import { render, staticRenderFns } from "./nbpFundsBeneficiaryComponent.vue?vue&type=template&id=114a32d0&"
import script from "./nbpFundsBeneficiaryComponent.vue?vue&type=script&lang=js&"
export * from "./nbpFundsBeneficiaryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports